export enum ERuntimeSettings {
  /** Тоггл калькулятора */
  PromoCalculatorEnabled = 'deal-sale-promo-frontend.PromoCalculator.Enabled',
  /** Тоггл доступа к странице */
  IsPublicAccessEnabled = 'deal-sale-promo.IsPublicAccess.Enabled',
  /** Тоггл СБР */
  PromoVtbSigningEnabled = 'e2e-deal-sale.PromoVtbSigning.Enabled',
  /** Тоггл Аккредитива */
  AccreditiveOnPromoPageEnabled = 'e2e-deal-sale.AccreditiveOnPromoPage.Enabled',
  /** Тоггл банк Абсолют */
  OnlineMeetingAbsolutBankEnabled = 'e2e-reference.OnlineMeetingAbsolutBank.Enabled',

  /** Телефон поддержки */
  CustomSupportContactPhone = 'e2e-deal-sale.customSupportContactPhone',
  /** Email поддержки */
  CustomerSupportContactEmail = 'e2e-deal-sale.customerSupportContactEmail',
  /** Основной урл промки b2c */
  DealSalePromoB2cFBaseUrl = 'deal-sale-promo-b2c-frontend.baseUrl',
  /** Урл прайс-листа */
  PriceListUrl = 'deal-sale-promo-frontend.priceListUrl',
  /** Урл формы сделки */
  RequestFormE2eUrl = 'request-form-e2e-frontend.url',
  /** ??? */
  ServicePresentationUrl = 'deal-sale-promo-frontend.servicePresentationUrl',
  /** Данные о цене сделки */
  PriceData = 'deal-sale-promo-frontend.priceData',
  /** Урл видео по Сделке */
  DealProcessVideoIframeUrl = 'deal-sale-promo.dealProcessVideoIframeUrl',
  /** Основные общие данные для футера */
  E2eDealSaleCommonFooterData = 'e2e-deal-sale.commonFooterData',
}
